import { useQuery } from '@tanstack/react-query';
import apiClient from '../api-client';

export type SquaresOption = {
  id: string;
  square_number: number | null;
  row_index: number | null;
  col_index: number | null;
  entry_count: number;
  win_probability: number; // 0.0 to 1.0
};

export type GetSquaresOptionsResponse = {
  question_id: string;
  options: SquaresOption[];
  square_to_option_map: Record<number, string>; // Maps square number (1-100) to option ID
  row_digits: number[] | null; // Randomized 0-9 sequence for rows
  col_digits: number[] | null; // Randomized 0-9 sequence for columns
  total_entries: number;
};

export const getSquaresOptions = (questionId: string) =>
  apiClient.get<GetSquaresOptionsResponse>(`/api/squares/${questionId}/options`);

export const useGetSquaresOptionsQuery = (questionId: string | null) => {
  return useQuery<GetSquaresOptionsResponse>({
    queryKey: ['squares', 'options', questionId],
    queryFn: async () => {
      if (!questionId) throw new Error('Question ID is required');
      const result = await getSquaresOptions(questionId);
      // API client interceptor unwraps response.data, so result is already GetSquaresOptionsResponse
      return result as unknown as GetSquaresOptionsResponse;
    },
    enabled: !!questionId,
  });
};
